/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_RecoveryInputs */

const en_control_recovery = /** @type {(inputs: Control_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your next route`)
};

const zh_control_recovery = /** @type {(inputs: Control_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续探索`)
};

/**
* | output |
* | --- |
* | "Find your next route" |
*
* @param {Control_RecoveryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_recovery = /** @type {((inputs?: Control_RecoveryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_RecoveryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_recovery(inputs)
	return zh_control_recovery(inputs)
});
export { control_recovery as "control.recovery" }